import React from "react";
import { useSmoothScroll } from "./useSmoothScroll";
import { Navbar } from "./Navbar";
import { Hero } from "./Hero";
import { BrandMarquee } from "./BrandMarquee";
import { About } from "./About";
import { Services } from "./Services";
import { Gallery } from "./Gallery";
import { Process } from "./Process";
import { WhyChoose } from "./WhyChoose";
import { Testimonials } from "./Testimonials";
import { ServiceArea } from "./ServiceArea";
import { FAQ } from "./FAQ";
import { QuoteForm } from "./QuoteForm";
import { Footer } from "./Footer";
import { FloatingActions } from "./FloatingActions";

export const Landing = () => {
  useSmoothScroll();
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <BrandMarquee />
        <About />
        <Services />
        <Gallery />
        <Process />
        <WhyChoose />
        <Testimonials />
        <ServiceArea />
        <FAQ />
        <QuoteForm />
      </main>
      <Footer />
      <FloatingActions />
    </>
  );
};

export default Landing;
